// extracted by mini-css-extract-plugin
export var main = "layout-module--main--a986f";
export var wrapper = "layout-module--wrapper--6e8fc";